import store from '../store/index.js';
import ApiService from './api.service.js';
const SUPER_ADMIN = 'superAdmin';

export default {
  async getPermissionConfig(fileName) {
    return await ApiService.get('/configurations', {
      params: { fileName: fileName }
    });
  },
  async canExecute(action) {
    if (!action) {
      return true;
    }

    const user = store.state.profile.profileData;
    if (user && user.role) {
      if (user.role === SUPER_ADMIN) {
        return true;
      }

      const permissions = store.getters.permissions;
      // if (!permissions) {
      //   await store.dispatch('getPermissions');
      //   permissions = store.state.permissions.permissions;
      // }

      const allowedRoles = this.getDeepValue(permissions, action);
      const result = !!(
        allowedRoles &&
        (allowedRoles === '*' ||
          allowedRoles.includes(user.role) ||
          (allowedRoles.includes('creator') && user.isCreator === true))
      );
      return result;
    }
    return false;
  },
  getDeepValue(source, field) {
    field = field.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    field = field.replace(/^\./, ''); // strip a leading dot
    const path = field.split('.');
    for (let i = 0, n = path.length; i < n; ++i) {
      const partName = path[i];
      if (source && partName in source) {
        source = source[partName];
      } else {
        return;
      }
    }
    return source;
  }
};
